import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_INCOMING_PREFIX_URL } from './constants/config.document-incoming'

const ListPageAll = lazy(() => import('./pages/ListPage.All.DocumentIncoming'))
const ListPageMyCreated = lazy(
  () => import('./pages/ListPage.MyCreated.DocumentIncoming')
)
const ListPageMyProcess = lazy(
  () => import('./pages/ListPage.MyProcess.DocumentIncoming')
)
const ListPageWaitingApproval = lazy(
  () => import('./pages/ListPage.WaitingApproval.DocumentIncoming')
)
const DetailPage = lazy(() => import('./pages/DetailPage.DocumentIncoming'))
const ReportPage = lazy(() => import('./pages/Report.DocumentIncoming'))

const DocumentIncomingRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/report`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/all`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAll />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/my-created`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageMyCreated />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/my-process`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageMyProcess />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/waiting-approval`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageWaitingApproval />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/report/:documentIncomingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/all/:documentIncomingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/my-created/:documentIncomingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/my-process/:documentIncomingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_INCOMING_PREFIX_URL}/waiting-approval/:documentIncomingId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentIncomingRouters
